import type { Theme } from '@mui/material';

export const styles = {
  successSnackbarCheckmark: (theme: Theme) => ({
    borderRadius: '50%',
    bgcolor: theme.colors.success[500],
    width: '2.5rem',
    height: '2.5rem',
    color: theme.colors.white,
    justifyContent: 'center',
    flexDirection: 'column',

    svg: {
      margin: 'auto',
    },
  }),
};
